function HeroSection() {
  return (
    <section
      style={{
        minHeight: "700px",
        background: "linear-gradient(90deg, #16295c 0%, #1f3f7a 55%, #239b95 100%)",
        display: "flex",
        alignItems: "center",
        padding: "60px 40px"
      }}
    >
      <div
  style={{
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "40px",
    paddingLeft: "20px",
    paddingRight: "20px"
  }}
>
        <div style={{ flex: 1, marginLeft: "-10px" }}>
          <div
            style={{
              display: "inline-block",
              padding: "10px 18px",
              borderRadius: "999px",
              border: "1px solid rgba(255,255,255,0.2)",
              color: "#d9f3f2",
              marginBottom: "28px",
              fontSize: "16px"
            }}
          >
            企業向け学習プラットフォーム
          </div>

          <h1
            style={{
              fontSize: "64px",
              lineHeight: 1.2,
              color: "white",
              margin: "0 0 28px 0",
              fontWeight: 700
            }}
          >
            プロフェッショナル研修で<br />
            チームの力を最大化
          </h1>

          <p
            style={{
              fontSize: "18px",
              color: "#d4d9e5",
              maxWidth: "620px",
              lineHeight: 1.8,
              marginBottom: "32px"
            }}
          >
            組織の学習体験を革新し、研修の効率化、
            進捗管理、成果向上を実現する
            学習管理システムです。
          </p>

          <div style={{ display: "flex", gap: "18px" }}>
            <button
              style={{
                backgroundColor: "#2fb3a6",
                color: "white",
                border: "none",
                borderRadius: "14px",
                padding: "16px 30px",
                fontSize: "18px",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              今すぐ始める
            </button>

            <button
              style={{
                backgroundColor: "rgba(255,255,255,0.08)",
                color: "white",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "14px",
                padding: "16px 30px",
                fontSize: "18px",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              デモを見る
            </button>
          </div>
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "520px",
              backgroundColor: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.18)",
              borderRadius: "20px",
              padding: "34px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
            }}
          >
            <p style={{ color: "#dbe8ef", fontSize: "22px", marginBottom: "10px" }}>
              学習進捗
            </p>

            <h2 style={{ color: "#081b33", fontSize: "48px", margin: "0 0 24px 0" }}>
              87% 完了
            </h2>

            <div
              style={{
                width: "100%",
                height: "16px",
                borderRadius: "999px",
                backgroundColor: "rgba(255,255,255,0.25)",
                overflow: "hidden",
                marginBottom: "34px"
              }}
            >
              <div
                style={{
                  width: "87%",
                  height: "100%",
                  backgroundColor: "#2fb3a6",
                  borderRadius: "999px"
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center"
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "34px", color: "#081b33" }}>24</h3>
                <p style={{ marginTop: "8px", color: "#dbe8ef" }}>コース数</p>
              </div>

              <div>
                <h3 style={{ margin: 0, fontSize: "34px", color: "#081b33" }}>156</h3>
                <p style={{ marginTop: "8px", color: "#dbe8ef" }}>ユーザー数</p>
              </div>

              <div>
                <h3 style={{ margin: 0, fontSize: "34px", color: "#081b33" }}>12</h3>
                <p style={{ marginTop: "8px", color: "#dbe8ef" }}>修了証</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;